import { ReducerActionRotaSP } from 'store/modules/types';

import { Types, IRequestWithHeaderLocalidadeCreate } from './types';

export function cadastrarLocalidadeRequest(
	token: string,
	payload: IRequestWithHeaderLocalidadeCreate,
) {
	return {
		type: Types.CADASTRAR_LOCALIDADE_REQUEST,
		token,
		payload,
	};
}
export function cadastrarLocalidadeSuccess(
	payload: object,
): ReducerActionRotaSP {
	return {
		type: Types.CADASTRAR_LOCALIDADE_SUCCESS,
		payload,
	};
}
export function cadastrarLocalidadeFailure(): ReducerActionRotaSP {
	return {
		type: Types.CADASTRAR_LOCALIDADE_FAILURE,
		payload: null,
	};
}
export function cadastrarLocalidadeClear(): ReducerActionRotaSP {
	return {
		type: Types.CADASTRAR_LOCALIDADE_CLEAR,
		payload: null,
	};
}
